// src/plugins/sales-forecast/components/ResetControl.tsx
import React from "react";
import { useSystemTheme } from "../hooks/useSystemTheme";
import "../../sales-forecast/styles/theme.css";

interface ResetControlProps {
  onReset: () => void;
}

export const ResetControl: React.FC<ResetControlProps> = ({ onReset }) => {
  const theme = useSystemTheme();

  // Pull system theme colors from CSS variables
  const css = getComputedStyle(document.documentElement);
  const textColor = css.getPropertyValue("--text-color").trim();
  const accentColor = css.getPropertyValue("--accent-color").trim();
  const inputBg = css.getPropertyValue("--input-bg").trim(); // darker tone
  const borderColor = css.getPropertyValue("--border-color").trim();

  // Fallback in case --input-bg isn't defined
  const defaultBg = inputBg || "var(--subcard-bg)";

  return (
    <button
      onClick={onReset}
      className={`theme-${theme} transition-all duration-200 rounded-lg font-medium`}
      style={{
        backgroundColor: defaultBg,
        color: textColor,
        border: `1px solid ${borderColor}`,
        padding: "0.5rem 1rem",
        boxShadow: "0 1px 4px rgba(0, 0, 0, 0.15)",
        cursor: "pointer",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.backgroundColor = accentColor;
        e.currentTarget.style.color = "#fff";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = defaultBg;
        e.currentTarget.style.color = textColor;
      }}
    >
      Reset to Defaults
    </button>
  );
};